import { Component, OnInit } from "@angular/core";
import { sdk } from '../../shared/helpers/biuwer-sdk-config';
import { environment } from "@env/environment";
import { AppState } from "app/app.reducer";
import { Store } from "@ngrx/store";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  accessType: string;
  biuwerInfo: any;
  showModal: boolean = false;

  constructor(
    private store: Store<AppState>,
  ) {
  }

  ngOnInit() {
    this.store.select("auth").subscribe((s) => {
      const st: any = s;
      this.accessType = st.user.accessType?.toLowerCase()
      let resourceTokenId
      let authTokenId
      let parentElement = "biuwer-container";
      const FEATURE_ID = 'feature_2025_08_biuwer';
        const superAdminToken = environment.baseUrlApi === "http://localhost:4000/api/v1" || environment.baseUrlApi === "https://demo-api.vyootrip.com/api/v1" ? 'e2f9a5a0-4131-11f0-ae9d-0d9155305dbc' : 'ba33ad90-5d93-11f0-9b20-d5908acdd5d6';
        const agencyToken = environment.baseUrlApi === "http://localhost:4000/api/v1" || environment.baseUrlApi === "https://demo-api.vyootrip.com/api/v1" ? 'defff8c0-5d8b-11f0-9b20-d5908acdd5d6' : 'd20b0a80-5d93-11f0-9b20-d5908acdd5d6';
        const companyToken = environment.baseUrlApi === "http://localhost:4000/api/v1" || environment.baseUrlApi === "https://demo-api.vyootrip.com/api/v1" ? '4d1bd680-5d8c-11f0-9b20-d5908acdd5d6' : 'e9fbbbd0-5d93-11f0-9b20-d5908acdd5d6';
        const biuwer = localStorage.getItem('biuwer')
        this.biuwerInfo = JSON.parse(biuwer)
        if (this.biuwerInfo) {
          resourceTokenId = this.accessType === "employee" ? superAdminToken : this.accessType === "agency" ? agencyToken : companyToken ;
          authTokenId = this.biuwerInfo.auth_tokens[0];
          // acceso denegado -> resource id mal
          // pagina no encontrada -> auth token mal o inactivo¿?
          sdk.renderSharedContent({ resourceTokenId, authTokenId, parentElement });
        }
        if (st && st.isAuthenticated) {
          if (!localStorage.getItem(FEATURE_ID) || localStorage.getItem(FEATURE_ID) !== FEATURE_ID + '_completed') {
            this.showModal = true
            localStorage.setItem(FEATURE_ID, 'feature_2025_08_biuwer_completed');
          }
        }
    })
  }
}
